import "./styles.scss";

import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useApp } from "context/app";
import { useNewWebsite } from "context/client/new_website";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import ProgressBarSteps from "components/ProgresBarSteps";

import Domain from "./components/steps/Domain";
import ChoosePlan from "./components/steps/ChoosePlan";
import YourData from "./components/steps/YourData";
import CheckYourData from "./components/steps/CheckYourData";
import Confirmation from "./components/steps/Confirmation";
import Loader from "components/Loader";
import ScrollTopMobile from "components/ScrollTopMobile";

import useResponsive from "libs/helpers/useResponsive";

const mainClass = "new-website-content";

const form_type_render = (step) => {
  switch (step) {
    case 0:
      return <Domain />;
    case 1:
      return <ChoosePlan />;
    case 2:
      return <YourData />;
    case 3:
      return <CheckYourData />;
    case 4:
      return null;
    case 5:
      return <Confirmation />;
    default:
      return null;
  }
};

const NewWebsiteContent = () => {
  const { t } = useTranslation();
  const { max } = useResponsive();

  const [loading, setLoading] = useState(true);
  const { websites } = useApp();
  const {
    step,
    setStep,
    loading: init_loading,
    change_plan_mode,
    step_touched,
  } = useNewWebsite();
  const { search } = useLocation();

  const query = new URLSearchParams(search);
  const isResult = query.get("result") === "success";

  useEffect(() => {
    if (isResult) setStep(5);

    window.scroll({
      top: 0,
      behavior: "instant",
    });

    setLoading(false);
    // eslint-disable-next-line
  }, [step, isResult]);

  const progress_data = [
    t("Add website"),
    t("Choose a plan"),
    t("Enter data"),
    t("Checkout"),
    t("Payment"),
    t("Confirmation"),
  ];

  const actions = [
    ...(websites?.length > 0
      ? [
          {
            type: "create_client_task",
            onboarding_button: true,
          },
        ]
      : []),
  ];

  return (
    <DashboardContentLayout
      header={{
        label: t(!!change_plan_mode ? "Change plan" : "New website"),
        description: t(
          !!change_plan_mode
            ? "Choose the plan that suits you best."
            : "Add your website to Webinity in a few simple steps.",
        ),
      }}
      loading={init_loading}
      actions={actions}
    >
      {!loading ? (
        <div className={mainClass}>
          {max.sm && step === 0 && (
            <Domain.Info change_plan_mode={change_plan_mode} />
          )}
          <ProgressBarSteps
            data={progress_data}
            hiddenMobileSteps={[4]}
            step={step}
            setStep={setStep}
            step_touched={step_touched}
            isResult={isResult}
          />
          <div className={`${mainClass}__wrapper`}>
            {form_type_render(step)}
          </div>
          {max.sm && !(change_plan_mode && step === 5) && (
            <div className={`${mainClass}__scroll`}>
              <ScrollTopMobile />
            </div>
          )}
        </div>
      ) : (
        <div className={`${mainClass}__loader`}>
          <Loader color="blue" center size="large" />
        </div>
      )}
    </DashboardContentLayout>
  );
};

export default NewWebsiteContent;
